export const numberFormatter = Intl.NumberFormat("en-US");

export function parseNumberString(numberStr) {
    return String(numberStr.replaceAll(/[^\d.]+/g, ""));
}
